module.exports = __webpack_public_path__ + "img/new_home.9254ef55.svg";